import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

const MuiLoader: React.FC<{ message?: string, textColor?: string, loaderSize?: number, loaderColor?: string, bgTransparency?: number }> = ({ message="", textColor = "inherit", loaderSize = 50, loaderColor = "inherit", bgTransparency = 0.5 }) => (
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bgcolor: `rgba(0, 0, 0, ${bgTransparency})`,
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <CircularProgress size={loaderSize} sx={{ color: loaderColor }} />
    {message.length > 0 && <Typography variant="h6" color={textColor}>
      {message}
    </Typography>}
  </Box>
);

export default MuiLoader;
